/*****************************************************************************************
 * 설명 : 관리자 > 컨텐츠관리 > 기본 메뉴 설정
 * URI : /admin/cms/menuList
*****************************************************************************************/
import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';

import useGridConfig from 'hooks/useGridConfig';
import { ButtonEx } from 'components/inputEx';

import { BtnSearch } from 'components/common';
import BtnAgGridSave from 'components/btnAgGridSave';
import ChipEx from 'components/chipEx';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const TabContentsLog = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [gridConfig, setGridUpdate] = useGridConfig(1);

  const [list] = useState([]);

  // ag grid 컬럼 선언
  const [columnDefs] = useState([
    { headerName: '관리번호(관리자용)', field: 'seq', width: 30, cellClass: 'center', flex: 0,
      headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true },
    {headerName: '구분', field: 'IUD', width: 100, cellClass: 'cp center',
      cellRenderer: (params) => {
        if( params.data.IUD === 'I' )
          return <ChipEx color="success" variant="outlined" size="small" label="추가" />;
        if( params.data.IUD === 'U' )
          return <ChipEx color="primary" variant="outlined" size="small" label="수정" />;
        else
          return <ChipEx color="error" variant="outlined" size="small" label="삭제" />;
      }
    },
    {headerName: '수정일시', field: 'updateDate', width: 100, cellClass: 'cp center'},
    {headerName: '메뉴명', field: 'pageName', width: 100, cellClass: 'cp center'},
    {headerName: '메뉴표시명', field: 'pageMenuName', width: 150, cellClass: 'cp' },
    {headerName: '게시판명', field: 'boardName', width: 150, cellClass: 'cp' },
    {headerName: '모듈명', field: 'moduleName', width: 200, cellClass: 'cp' },
    {headerName: '모듈패스', field: 'modulePath', width: 150, cellClass: 'cp' },
    {headerName: '메인메뉴표시', field: 'isMainmenuView', width: 90, cellClass: 'cp',
      cellRenderer: (params) => {
        if( params.data.isMainmenuView === '1' )
          return <ChipEx color="success" variant="outlined" size="small" label="표시" />;
        else
          return <ChipEx color="error" variant="outlined" size="small" label="표시안함" />;
      }
    },
    {headerName: '메뉴표시', field: 'isMenuView', width: 100, cellClass: 'cp center',
      cellRenderer: (params) => {
        if( params.data.isMenuView === '1' )
          return <ChipEx color="success" variant="outlined" size="small" label="표시" />;
        else
          return <ChipEx color="error" variant="outlined" size="small" label="표시안함" />;
      }
    },
    {headerName: '링크주소', field: 'linkUrl', width: 200, cellClass: 'cp' },
    {headerName: '쿼리스트링', field: 'queryString', width: 200, cellClass: 'cp' },
    {headerName: '새창표시', field: 'isLinkOpen', width: 100, cellClass: 'cp center',
      cellRenderer: (params) => {
        if( params.data.isLinkOpen === 'C' )
          return <ChipEx color="success" variant="outlined" size="small" label="현재창" />;
        else if( params.data.isLinkOpen === 'N' )
          return <ChipEx color="primary" variant="outlined" size="small" label="새창" />;
        else if( params.data.isLinkOpen === 'P' )
          return <ChipEx color="secondary" variant="outlined" size="small" label="팝업" />;
        else
          return '';
      }
    },
    {headerName: '게시판', field: 'boardSeq', width: 100, cellClass: 'cp center',
      cellRenderer: (params) => {
        if( params.data?.listType.indexOf('C') > -1 ) {
          return <ChipEx color="success" variant="outlined" size="small" label="사용" />;
        } else {
          return <ChipEx color="secondary" variant="outlined" size="small" label="사용안함" />;
        }
      }
    },
    {headerName: '그룹사용', field: 'listTypeGroup', width: 100, cellClass: 'cp center',
      cellRenderer: (params) => {
        if( params.data.listTypeGroup === 1 ) {
          return <ChipEx color="success" variant="outlined" size="small" label="사용" />;
        } else {
          return <ChipEx color="secondary" variant="outlined" size="small" label="사용안함" />;
        }
      }
    },
  ]);

  /***************************************************************************************
   * 설명 : 컨텐츠 데이터 로그 가져오기
  ***************************************************************************************/
  const getList = () => {

  }

  /***************************************************************************************
   * 설명 : 데이터 로딩 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 0 ) {
    }

    // eslint-disable-next-line
  }, []);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <>
      {props.siteSeq === '' &&
        <section className="pt10">
          <div className="menu-list-add-background">
            사이트를 선택 후에 '메뉴등록' 혹은 '메뉴선택'을 진행해주세요.
          </div>
        </section>
      }

      {props.siteSeq !== '' &&
        <>
          { ( props.data.seq === undefined || props.data.siteSeq === undefined ) &&
            <section className="pt10">
              <div className="menu-list-add-background">
                메뉴를 선택하시기 바랍니다.
              </div>
            </section>
          }
          { props.data.seq !== undefined && props.data.siteSeq !== undefined &&
            <>
              <section className="">
                <header className="admin-cms-search-header">
                  <div className="left">
                    <BtnSearch click={() => getList()}></BtnSearch>
                    <BtnAgGridSave click={setGridUpdate}></BtnAgGridSave>
                  </div>

                  <div className="right">
                    <ButtonEx
                      title="선택된 로그로 되돌리기"
                      auth="authModify"
                      color="primary"
                      className="ml5"
                      variant="contained"
                      onClick={() => {
                      }}
                    />
                  </div>
                </header>

                <section className="ag-theme-balham grid mt10" style={{height: 'calc(100vh - 180px)'}}>
                  <AgGridReact
                    defaultColDef={{
                      sortable: true,
                      resizable: true,
                      filter: false,
                      lockVisible: true
                    }}
                    rowSelection = {'multiple'}
                    columnDefs={columnDefs}
                    rowData={list}
                    onGridReady={(event) => {
                      gridConfig(event.api);
                    }}
                    rowDragManaged={true}
                    rowDragMultiRow={true}
                    animateRows={true}
                    overlayNoRowsTemplate = "검색된 내용이 없습니다."
                  />
                </section>
              </section>
            </>
          }
        </>
      }
    </>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default TabContentsLog;